export class OutageGlobalIdManageRequest {
    outageId?: string | undefined;
    globalId?: number;

    constructor(data?: OutageGlobalIdManageRequest) {
        this.outageId = data?.outageId;
        this.globalId = data?.globalId;
    }
}